import { atom } from 'nanostores'

export const currentUrl = atom('')
